import script from "./EventSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSchedule.vue?vue&type=script&setup=true&lang=js"

import "./EventSchedule.vue?vue&type=style&index=0&id=28402695&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28402695"]])

export default __exports__